import { VariantsActionTypes } from './constants';

/* =======================
   Interfaces
======================= */

interface VariantNames {
    english?: string;
    hindi?: string;
    gujarati?: string;
}

interface VariantAddPayload {
    item_id: string;
    business_id: string;
    variant_name: VariantNames;
    description?: string;
    price: number;
}

/* =======================
   Action Types
======================= */

export type VariantsAction =
    | {
          type: typeof VariantsActionTypes.VARIANTS_ADD;
          payload: VariantAddPayload;
      }
    | {
          type: typeof VariantsActionTypes.VARIANTS_ADD_SUCCESS;
          payload: { message: string };
      }
    | {
          type: typeof VariantsActionTypes.VARIANTS_ADD_ERROR;
          payload: { error: string };
      };

/* =======================
   Action Creators
======================= */

export const variantsAdd = (data: VariantAddPayload): VariantsAction => ({
    type: VariantsActionTypes.VARIANTS_ADD,
    payload: data,
});

export const variantsAddSuccess = (message: string): VariantsAction => ({
    type: VariantsActionTypes.VARIANTS_ADD_SUCCESS,
    payload: { message },
});

export const variantsAddError = (error: string): VariantsAction => ({
    type: VariantsActionTypes.VARIANTS_ADD_ERROR,
    payload: { error },
});
